import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { fetchCountryProvider } from 'src/api/authen';

type ProviderCountryOption = {
  label: string;
  value: string;
};

type ProviderCountrySelectProps = {
  
  onChange?: (countries: string[]) => void;
  
  width?: number;
  
  includeAllOption?: boolean;
  value?: string[]                 
  defaultValue?: string[]         
};

const ProviderCountrySelect: React.FC<ProviderCountrySelectProps> = ({
  onChange,
  width = 200,
  includeAllOption = true,
  value,
  defaultValue,
}) => {
  const [countries, setCountries] = useState<ProviderCountryOption[]>([]);
  const [selectedCountryValue, setSelectedCountryValue] = useState<string[]>(['ALL']);
  const [loading, setLoading] = useState<boolean>(false);
 const isControlled = value !== undefined
  useEffect(() => {
    let mounted = true

    const fetchCountry = async () => {
      try {
        setLoading(true)
        const data = await fetchCountryProvider()

        const fetchedCountryOptions: ProviderCountryOption[] = data.data.map((item: any) => ({
          label: item.countryName,
          value: item.countryCode,
        }))

        const allOption: ProviderCountryOption | null = includeAllOption
          ? { label: 'ALL', value: 'ALL' }
          : null

        const finalCountryOptions = allOption
          ? [allOption, ...fetchedCountryOptions]
          : fetchedCountryOptions

        if (mounted) setCountries(finalCountryOptions)
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        if (mounted) setLoading(false)
      }
    }

    fetchCountry()
    return () => {
      mounted = false
    }
  }, [includeAllOption])

 
  useEffect(() => {
    if (!isControlled) return
    setSelectedCountryValue(value ?? [])
  }, [isControlled, value])

 
useEffect(() => {
    if (!countries.length) return
    if (isControlled) return

    
    if (defaultValue?.length) {
      setSelectedCountryValue(defaultValue)
      onChange?.(defaultValue)
      return
    }

   
    const uiValue = includeAllOption ? ['ALL'] : [countries[0].value]
    setSelectedCountryValue(uiValue)

    const initialList = includeAllOption
      ? countries.map((option) => option.value)
      : uiValue

    onChange?.(initialList)
  }, [countries, includeAllOption, isControlled, defaultValue])
  const handleCountryChange: SelectProps['onChange'] = (val) => {
    let countriesList: string[]

    if (Array.isArray(val)) {
      if (includeAllOption && val.includes('ALL')) {
        countriesList = countries.map((option) => option.value)
      } else {
        countriesList = val
      }
    } else {
      if (includeAllOption && val === 'ALL') {
        countriesList = countries.map((option) => option.value)
      } else {
        countriesList = [val]
      }
    }

    
    if (!isControlled) setSelectedCountryValue(countriesList)

    onChange?.(countriesList)
  }

  return (
    <Select
     
      value={isControlled ? value : selectedCountryValue}  
      style={{ width }}
      onChange={handleCountryChange}
      options={countries}
      loading={loading}
    />
  );
};

export default ProviderCountrySelect;
